import React from 'react';
import s from '../SipCalBtfWidget/SipCalBtfWidget.scss';

const EMICalcBtfWidget = ({ pageData, isMobile }) => {
  const data = {
    qna: [
      {
        que: 'What is EMI?',
        ans: [
          'Equated Monthly Installment or EMI as it is commonly called is the fixed amount that you need to pay a borrower pays to their lender on a designated day in a periodic time span. This EMI payment is designed to settle both the principal and interest of the loan over a defined period until the loan is completely repaid. EMIs are commonly associated with various types of loans, including home loans, personal loans, and car loans.',
          'The EMI comprises two primary elements; Principal, which is the amount borrowed, and Interest, which is the cost of borrowing the money.',
          'The calculation of the EMI takes into account the loan amount, the interest rate, and the loan tenure. Usually, in the initial stages of the loan, a more significant portion of the EMI is allocated towards paying the interest. However, as the loan progresses, a larger share of the EMI is directed towards reducing the principal balance.',
        ],
      },
      {
        que: 'How can the online EMI calculator help you?',
        ans: [
          'Planning your finances is an important part of long-term goal setting and an EMI calculator is an effective tool to help you understand your ability to take a loan, whether home loan, car loan, education loan or a personal loan. By helping you arrive at the estimated EMI amount, the EMI calculator aims to make an informed decision on your repayment capability, hence allowing you to avoid any future debt traps.',
          'By eliminating the need for manual calculations, EMI calculators save time and reduce the risk of errors.',
          'You can also use the EMI calculator to compare different loan options from various lenders.',
        ],
      },
      {
        que: 'How to use the EMI calculator?',
        ans: [
          'The EMI calculator is a very simple and effective tool to use. All you need is the loan amount, the interest rate and the loan tenure over which you plan to make the repayment.',
          'The calculator instantly provides you with an EMI amount based on the loan amount, interest rate, and tenure you input.',
        ],
      },
      {
        que: 'What is the formula used to determine loan EMI amount?',
        ans: ['The formula used in the above calculator is:'],
      },
      {
        que: 'What factors determine the EMI amount?',
        ans: [
          'When planning to apply for a loan, there are several factors to consider based on your financial and repayment capacity.',
          'One crucial aspect is calculating EMIs the loan’s tenure. A shorter tenure will result in higher EMIs, while a longer tenure will lead to lower EMIs. Another essential factor to consider is the rate of interest, as it directly impacts the installment amount owed. The loan amount you choose is also significant in determining your EMI, as it will be calculated accordingly.',
        ],
      },
    ],
  };
  return (
    <>
      <div className={s.commonBlockWrap}>
        <div className={`${s.common_block} ${isMobile ? '' : 'mb40'}`}>
          {pageData && <div dangerouslySetInnerHTML={{ __html: pageData }} />}
          {!pageData && data && data?.description && <p>{data?.description}</p>}
          {!pageData &&
            data &&
            data.qna.map &&
            Array.isArray(data.qna) &&
            data.qna.length > 0 &&
            data.qna.map((desc, index) => (
              <>
                {desc.que && <h3>{desc.que}</h3>}
                {index !== 3 &&
                  desc.ans && (
                    <ul>
                      {desc.ans && desc.ans.map(answer => <li>{answer}</li>)}
                    </ul>
                  )}
                {index === 3 &&
                  desc.ans && (
                    <ul>
                      <li>The formula used in the above calculator is:</li>
                      <p> P x R x (1+R)^N / [(1+R)^N-1] </p>
                      <p> Where: </p>
                      <p>
                        <li>P = Principal loan amount</li>
                      </p>
                      <p>
                        <li>N = Loan tenure in months</li>
                      </p>
                      <p>
                        <li>R = Monthly interest rate</li>
                      </p>
                      <p>
                        <li>
                          The rate of interest (R) on your loan is calculated
                          per month.
                        </li>
                      </p>
                      <p>
                        <li>
                          R = Annual Rate of interest/12/100<br />So, for
                          example, if the rate of interest is 7.2% p.a. then r =
                          7.2/12/100 = 0.006
                        </li>
                      </p>

                      {/* <li>
                        
                      </li> */}
                    </ul>
                  )}
              </>
            ))}
        </div>
      </div>
    </>
  );
};

export default EMICalcBtfWidget;
